/*
 * Copyright (C) 2015 - 2018 Kosmos contact@kosmos.fr
 *
 * Projet: webapp-contrib
 * Version: 7.1.2
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *         http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
(function ($) {

    'use strict';

    /**
     * URL du controlleur calculant les impacts des modifications en cours sur la fiche.
     * @type {string}
     */
    const urlContentImpact = '/bo/url/impact/fiche';

    /**
     * URL du controlleur qui permet de vérifier si la fiche est une page de tête de rubrique.
     * @type {string}
     */
    const urlContentImpactHeadPage = '/bo/url/impact/ishomepage';

    /**
     * Selecteur permettant d'accéder à l'ID de la fiche.
     * @type {string}
     */
    const selectorIdFiche = '[name="ID_FICHE"]';

    /**
     * Selecteur permettant d'accéder au code de l'objet.
     * @type {string}
     */
    const selectorCodeObjet = '[name="CODE_OBJET"]';

    /**
     * Url de la servlet à appeler pour maintenir la session en vie.
     */
    const keepAliveServletUrl = '/servlet/com.kportal.servlet.KeepAliveServlet';

    // Cohabitation jQuery K-Sup et jQuery KFC (oui, c'est très laid).
    window.$ksup = $;

    // Delegate .transition() calls to .animate()
    // if the browser can't do CSS transitions.
    if (!$.support.transition) {
        $.fn.transition = $.fn.animate;
    }

    /**
     * Locale de la page courante
     */
    var locale = $('html').attr('lang');

    /**
     * Initialisation des champs de type date
     */
    $('.type_date').datepicker($.datepicker.regional[locale]);

    var saisieObjet = $('#saisie_objet');

    /**
     * Défini si le formulaire actuel peut être envoyé ou non.
     */
    var canSubmit = function (action) {
        if (action !== 'APERCU') {
            return true;
        }
        var sectionCodeInput = saisieObjet.find('input[name=CODE_RUBRIQUE]');
        return sectionCodeInput.val() === undefined || sectionCodeInput.val() !== '';
    };

    /**
     * Validation du formulaire en fonction de l'action
     */
    var validerFormulaireSaisie = function (source) {
        var action = source.data('action');
        if (!canSubmit(action)) {
            $('#messageApplicatif').html('<p class="notification notification--error">' + LOCALE_BO.mandatorySection + '</p>');
            return;
        }
        var onglet = source.data('onglet');
        var formulaire = source.closest('form');
        if (action === 'APERCU') {
            //permet de mettre à jour les input associés aux toolboxes avant de soumettre le formulaire en ajax
            for (let instance in CKEDITOR.instances )
                CKEDITOR.instances[instance].updateElement();
            const formulaireSaisie = document.getElementById('saisie_objet');
            let formData = new FormData(formulaireSaisie);
            formData.set('APERCU', '1');
            formData.set('ACTION', 'ENREGISTRER');
            fetch(formulaireSaisie.getAttribute('action'), {
                method: 'POST' ,
                body: formData
            })
                .then(response => response.json())
                .then(data => {
                    if (data.result === 'OK') {
                        window.open(data.preview, 'K-Sup-preview');
                    } else {
                        window.scrollTo(0, 0);
                        document.querySelector('#messageApplicatif').innerHTML ='<p class="notification notification--error">' +
                            '<button type="button" class="close" data-dismiss="alert" aria-hidden="true">×</button>' +
                            LOCALE_BO.previewError.replace('{errMsg}', data.messages) +
                            '</p>';
                    }
                })
                .catch((errorMsg) => {
                    window.scrollTo(0, 0);
                    document.querySelector('#messageApplicatif').innerHTML = '<p class="notification notification--error">' +
                        '<button type="button" class="close" data-dismiss="alert" aria-hidden="true">×</button>' +
                        LOCALE_BO.unexpectedPreviewError.replace('errMsg', errorMsg) +
                        '</p>';
                });
            return;
        } else if (action === 'COMPARER') {
            window.open(source.data('url'), 'comparison');
            return;
        } else {
            var validator = $.data(formulaire[0], 'validator');
            if (validator) {
                // allow suppressing validation by adding a cancel class to the submit button
                if (source.hasClass('cancel')) {
                    validator.cancelSubmit = true;
                }
                // allow suppressing validation by adding the html5 formnovalidate attribute to the submit button
                if (source.attr('formnovalidate')) {
                    validator.cancelSubmit = true;
                }
            }
            saisieObjet.find('input[name=ACTION]').val(action);
        }
        saisieObjet.find('input[name=SOUS_ONGLET_DEMANDE]').val(onglet || '');
        saisieObjet.submit();
        saisieObjet.find('input[name=APERCU]').val('0');
        saisieObjet.attr('target', '');
        saisieObjet.find('input[name=ACTION]').val(action);
    };

    /**
     * Gestion des actions sur les formulaires de saisies (enregistrer/dupliquer/supprimer...)
     */
    saisieObjet.find('[data-action]').on('click', async function () {
        const that = $(this);
        const actionAConfirmer = that.data('confirm');
        const formulaire = that.closest('form');
        if (that.attr('name') && that.attr('value')) {
            formulaire.append('<input type="hidden" name="' + that.attr('name') + '" value="' + that.attr('value') + '"/>');
        }
        let displayDefaultMessage = true;
        if(isContentCreation()) {
            if(that.data('action') === 'ENREGISTRER' && that.attr('value') === '0') {
                const nbImpacts = await getImpactInformation(this);
                if (nbImpacts > 0) {
                    const message = LOCALE_BO.pagesImpacts.replace('%d', nbImpacts);
                    sendFormOrAskForConfirmation(message, that);
                    displayDefaultMessage = false;
                }
            } else {
                if(isContentStateToDeleteOrArchive(that)) {
                    if (await isSectionHeadPage()) {
                        const isActionArchiving = that.data('action') === 'ARCHIVER';
                        const message = isActionArchiving ? LOCALE_BO.headPageImpact : LOCALE_BO.headPageImpactDelete;
                        sendFormOrAskForConfirmation(message, that);
                    } else {
                        sendFormOrAskForConfirmation(actionAConfirmer, that);
                    }
                    displayDefaultMessage = false;
                }
            }
        }
        if(displayDefaultMessage) {
            sendFormOrAskForConfirmation(actionAConfirmer, that);
        }
    });

    /**
     * Détermine si la fiche est en cours de création ou de modification.
     * Si aucun ID n'est présent, la fiche est en cours de création.
     * @return {boolean} true si création.
     */
    function isContentCreation() {
        const idFicheField = document.querySelector(selectorIdFiche);
        return idFicheField && idFicheField.value !== '0';
    }

    function isContentStateToDeleteOrArchive(actionButton) {
        const spanEtat = document.querySelector('.etat span');
        return spanEtat && spanEtat.classList.contains('enligne') && (actionButton.data('action') === 'ARCHIVER' || actionButton.data('action') === 'SUPPRIMER');
    }
    /**
     * Initialise les données de la page à transmettre.
     * Contient le code objet et l'id de la fiche.
     * @return {Object} les données.
     */
    function getPageDatas(form) {
        const data = {};
        data.codeObjet = form.querySelector(selectorCodeObjet).value;
        data.idFiche = form.querySelector(selectorIdFiche).value;
        return data;
    }

    /**
     * Calcule le nombre d'impacts de la modification en cours.
     * @param {Object} button le bouton source de l'événement.
     */
    async function getImpactInformation(button) {
        const pageData = getDataForImpacts(button);
        const url = urlContentImpact + '?' + (new URLSearchParams(pageData)).toString();
        const fetchData = await fetch(url, {
            headers: {
                Accept: 'application/json',
            },
        });
        const data = await fetchData.text();
        return Number.parseInt(data, 10);
    }

    /**
     * Interroge le BO pour savoir si la fiche en cours est une page de tête de rubrique.
     * @returns {Boolean} vrai s'il s'agit d'un page de tête de rubrique.
     */
    async function isSectionHeadPage() {
        try {
            const data = getPageDatas();
            const url = urlContentImpactHeadPage + '?' + (new URLSearchParams(data)).toString();
            const fetchData = await fetch(url, {
                headers: {
                    Accept: 'application/json',
                },
            });
            const result = await fetchData.text();
            return result === 'true';
        } catch (error) {
            return false;
        }
    }

    /**
     * Si une actionAConfirmer est présente, va demander la confirmation avant de valider le formulaire.
     * @param actionAConfirmer une actionAConfirmer
     * @param actionButton le bouton qui lance l'action
     */
    function sendFormOrAskForConfirmation(actionAConfirmer, actionButton) {
        if (actionAConfirmer) {
            $('<div>')
                .html(actionAConfirmer)
                .dialog({
                    buttons: [{
                        text: LOCALE_BO.ok,
                        click: function () {
                            $(this).dialog('close');
                            validerFormulaireSaisie(actionButton);
                        }
                    }, {
                        text: LOCALE_BO.fermer,
                        click: function () {
                            $(this).dialog('close');
                        }
                    }],
                    title: LOCALE_BO.confirmer
                });
        } else {
            validerFormulaireSaisie(actionButton);
        }
    }

    /**
     * Récupère les données de fiche pour le calcul d'impacts.
     * @returns Les données nécessaires au calcul d'impact
     */
    function getDataForImpacts(saveButton) {
        const form = saveButton.closest('form');
        const pageData = getPageDatas(form);

        if(document.querySelector('[name="DISPLAY-SLUG"]')){
            pageData.slug = document.querySelector('[name="DISPLAY-SLUG"]').value;
        } else if(saveButton) {
            pageData.slug = saveButton.getAttribute('data-slug');
        }
        if(document.querySelector('[name="CODE_RUBRIQUE"]')){
            pageData.codeRubrique = document.querySelector('[name="CODE_RUBRIQUE"]').value;
        } else if(saveButton) {
            pageData.codeRubrique = saveButton.getAttribute('data-section');
        }

        return pageData;
    }

    $('button[data-confirm]:not([data-action])').on('click', function () {
        var that = $(this);
        var formulaire = that.closest('form');
        var actionAConfirmer = that.data('confirm');
        $('<div>')
            .html(actionAConfirmer)
            .dialog({
                buttons: [{
                    text: LOCALE_BO.ok,
                    click: function () {
                        $(this).dialog('close');
                        if (formulaire.has('input[name="ACTION"]').length) {
                            $('input[name="ACTION"]').val(that.attr('name'));
                        } else {
                            formulaire.append('<input type="hidden" name="ACTION" value="' + that.attr('name') + '"/>');
                        }
                        formulaire.submit();
                    }
                }, {
                    text: LOCALE_BO.fermer,
                    click: function () {
                        $(this).dialog('close');
                    }
                }],
                title: LOCALE_BO.confirmer
            });
        return false;
    });

    /**
     * L'action refuser sur les fiches doit renvoyer une dialogue avec une textarea
     * On envoie ensuite le formulaire après avoir positionner un input "TYPE_ENREGISTREMENT" à 3
     * Pourquoi? euh bha c'est historique
     */
    $('.js-refuser').click(function () {
        var that = $(this);
        $('#dialogRefuser').dialog({
            buttons: [{
                text: LOCALE_BO.valider,
                click: function () {
                    var formulaire = that.closest('form');
                    formulaire.append('<input type="hidden" name="TYPE_ENREGISTREMENT" value="3" />');
                    $('[data-action="ENREGISTRER"]').click();
                    $(this).dialog('close');
                }
            }]
        });
    });

    $('.js-refusal-user').click(function () {
        var $this = $(this);
        $('.js-refusal-user__form').dialog({
            title: LOCALE_BO.userFront.title,
            buttons: [{
                text: LOCALE_BO.valider,
                click: function () {
                    var $form = $this.closest('form');
                    $form.append('<input type="hidden" name="' + $this.attr('name') + '" value="' + $this.val() + '" />');
                    $(this).dialog('close');
                    $form.submit();
                }
            }]
        });
    });

    /**
     * Tous les liens externes doivent s'ouvrir dans une nouvelle fenêtre
     * Les liens du BO sont tous en relatif (théoriquement) donc ceux qui commence par http(s)
     * s'ouvre en window.open sauf ceux spéciquement target="_self"
     */
    $('body').on('click', 'a[href^="http"]:not([target="_self"])', function () {
        window.open(this.href);
        return false;
    });

    /**
     * Binding des boutons "Paramètrer" et "Supprimer" du gestionnaire d'extensions
     */

    $('.extension_actions button.interrupteur:not(.verrou)').click(function () {
        var $this = $(this),
            name = $this.closest('.extension_actions').siblings('.infos').find('p:first-child').html(),
            extension = $this.closest('.extension').length > 0,
            target = $this.closest('li[id]').length > 0 ? $this.closest('li[id]').attr('id') : null,
            expandedIds = [];
        // Prepare ajax request
        var datas = {PROC: 'GESTION_EXTENSION', ACTION: extension ? 'ACTIVER_EXTENSION' : 'ACTIVER_MODULE'};
        if (extension) {
            datas.ID_EXTENSION = $this.data('extensionid');
        } else {
            datas.ID_MODULE = $this.data('extensionid');
        }

        // Retrieve currently expanded li
        $('.extension-modules.expanded').closest('li').each(function () {
            expandedIds.push($(this).attr('id'));
        });

        // Execute request and reload page
        $.simAsync({
            loaderMessage: (extension ? LOCALE_BO.lExtension : LOCALE_BO.leModule) + ' ' + name + ' ' + ($this.is('.on') ? LOCALE_BO.enCoursdeDesactivation : LOCALE_BO.enCoursdActivation) + LOCALE_BO.patienter,

            reloadParams: {EXPANDED: expandedIds.join(';')},
            reloadTarget: target,

            baseUrl: '/servlet/com.jsbsoft.jtf.core.SG',
            baseParams: datas,
            displayEndStatus: true,
            successMessage: ($this.is('.on') ? LOCALE_BO.enSuccesDesactivation : LOCALE_BO.enSuccesActivation),
            errorMessage: ($this.is('.on') ? LOCALE_BO.enErreurDesactivation : LOCALE_BO.enErreurActivation)
        });

        // Switch state
        if ($this.is('.on')) {
            $this.html(LOCALE_BO.activer);
            $this.removeClass('on').addClass('off');
        } else {
            $this.html(LOCALE_BO.desactiver);
            $this.removeClass('off').addClass('on');
        }
        if ($this.closest('li[id]').is('.actif')) {
            $this.removeClass('actif').addClass('inactif');
        } else {
            $this.removeClass('inactif').addClass('actif');
        }
    });

    $('.js-button--action-recharger').click(function () {
        var $this = $(this),
            url = $this.attr('href');
        $.simAsync({
            loaderMessage: LOCALE_BO.enCoursRechargement + LOCALE_BO.patienter,
            baseUrl: url,
            displayEndStatus: true,
            successMessage: LOCALE_BO.enSuccesRechargement,
            errorMessage: LOCALE_BO.enErreurRechargement
        });
        return false;
    });

    function updateExtensionsLayout($panel, animate) {
        $panel.each(function () {
            const marginBottom = 32;
            const $this = $(this);
            const $li = $this.closest('li');
            const height = $this.outerHeight() + ($li.innerHeight() - $li.height()) + marginBottom;
            if ($this.is('.expanded')) {
                $li.transition({height: '+=' + height + 'px'}, animate ? 500 : 0);
            } else {
                $li.transition({height: '-=' + height + 'px'}, animate ? 500 : 0);
            }
        });
    }

    $('.extension button.details').click(function () {
        var $this = $(this),
            $modulesPanel = $this.closest('.extension').siblings('.extension-modules');

        if ($modulesPanel.is('.collapsed')) {
            $this.removeClass('deplier').addClass('plier');
            $modulesPanel.removeClass('collapsed').addClass('expanded');
        } else {
            $this.removeClass('plier').addClass('deplier');
            $modulesPanel.removeClass('expanded').addClass('collapsed');
        }

        updateExtensionsLayout($modulesPanel, true);
    });

    $('.rights_action button.details').click(function () {
        var $this = $(this),
            $rightsPanel = $this.closest('.rights_informations').siblings('.rights');

        if ($rightsPanel.is('.collapsed')) {
            $this.removeClass('deplier').addClass('plier');
            $rightsPanel.removeClass('collapsed').addClass('expanded');
        } else {
            $this.removeClass('plier').addClass('deplier');
            $rightsPanel.removeClass('expanded').addClass('collapsed');
        }

        updateExtensionsLayout($rightsPanel, true);
    });

    updateExtensionsLayout($('.extension-modules.expanded'));

    /**
     * dropdowns bootstrap
     */
    $('.dropdown-toggle').dropdown();

    $('.infobulle').tooltip({
        html: true,
        placement: 'right',
        trigger: 'hover focus'
    });

    /**
     * Session keep alive when user is filling a form
     */
    function launchKeepAliveServlet() {
        const xmlHttp = new XMLHttpRequest();
        xmlHttp.open('GET', window.location.origin + keepAliveServletUrl + '.duration');
        xmlHttp.onreadystatechange = function() {
            let interval = 1740000;
            if (xmlHttp.readyState === 4 && xmlHttp.status === 200 && !!xmlHttp.response) {
                interval = xmlHttp.response;
            }
            setInterval(function () {
                $.ajax(window.location.origin + keepAliveServletUrl);
            }, interval);
        };
        xmlHttp.send();
    }
    launchKeepAliveServlet();

    $('.js-media-component').mediaComponent({});

    /**
     * Évènement défini sur l'enregistrement d'un site.
     */
    $('.js-save-site').click(function(){
        if(existUrlSiteImpact(this)) {
            const button = this;
            jQuery('<div>')
                .html(LOCALE_BO.siteImpacts)
                .dialog(
                    {
                        buttons: [{
                            text: LOCALE_BO.ok,
                            click: function () {
                                jQuery(this).dialog('close');
                                jQuery(button).closest('form').submit();
                            }
                        }, {
                            text: LOCALE_BO.fermer,
                            click: function () {
                                jQuery(this).dialog('close');
                            }
                        }],
                        title: LOCALE_BO.confirmer
                    });
        }else{
            jQuery(this).closest('form').submit();
        }
    });

    /**
     * Test s'il existe des impacts au niveau des urls sur la saisie d'une site.
     * @param saveButton le bouton d'enregistrement du formulaire
     * @returns {boolean} true s'il existe un impact
     */
    function existUrlSiteImpact(saveButton) {
        var retour = false;
        if (!saveButton.getAttribute('data-newSite')) {
            retour = retour || document.getElementById('CODE_RUBRIQUE').value !== saveButton.getAttribute('data-sitesection');
            retour = retour || document.getElementById('niveauDescendantMax').value !== saveButton.getAttribute('data-sitedown');
            retour = retour || document.getElementById('niveauMontantMax').value !== saveButton.getAttribute('data-siteup');
        }
        return retour;
    }

    var slugElement = document.getElementById('DISPLAY-SLUG');
    var slugAutoElement = document.querySelector('input[name="SLUG_AUTO"]');

    if(slugElement) {
        addEventListener('change', performSlugChange, false);
    }
    var urlUseTitleElement = document.getElementById('url__use-title');
    if(urlUseTitleElement) {
        urlUseTitleElement.addEventListener('click', useTitleForSlug, false);
    }

    displaySlugInfo();

    /**
     * Fonction appelée lorsque le slug est modifé par l'utilisateur
     */
    function performSlugChange() {
        document.querySelectorAll('.js-url__check-slug').forEach(function(element) {
            element.classList.add('masquer');
        });
        displaySlugInfo();
    }

    /**
     * Affichage du bloc d'info si slug déphasé par rapport au titre
     */
    function displaySlugInfo() {
        var updatedSlugElement = document.querySelector('.js-url__slug-updated');
        var displayInfo = slugElement && slugAutoElement && slugElement.value !== slugAutoElement.value;
        if(updatedSlugElement) {
            displayInfo ? updatedSlugElement.classList.remove('masquer') : updatedSlugElement.classList.add('masquer');
        }
    }

    /**
     * Evenement appelé pour synchroniser le slug avec le titre
     * @param event
     */
    function useTitleForSlug(event) {
        event.stopPropagation();
        if(slugElement && slugAutoElement) {
            slugElement.value = slugAutoElement.value;
        }
        var slugUpdated = document.querySelector('.js-url__slug-updated');
        if(slugUpdated) {
            slugUpdated.classList.add('masquer');
        }
        var slugError = document.querySelector('.js-url__check-slug');
        if(slugError) {
            slugError.classList.add('masquer');
        }
        slugError = document.querySelector('.js-section-urlError');
        if(slugError) {
            slugError.classList.add('masquer');
        }
    }

    /**
     * Si le bouton de modification de contexte de fiche est défini on lui donne son action.
     */
    var contextModificationButton = document.querySelector(".js-contextModification");
    if (contextModificationButton) {
        contextModificationButton.addEventListener(
            'click', function () {
                $('<div>')
                    .html(LOCALE_BO.confirmerQuitter)
                    .dialog(
                        {
                            buttons: [{
                                text: LOCALE_BO.ok,
                                click: function () {
                                    var idFicheInput = document.querySelector('input[name="ID_FICHE"]');
                                    if (idFicheInput && idFicheInput.value !== "0") {
                                        contextModificationButton.dataset.action = "MODIFIER_CONTEXTE";
                                        validerFormulaireSaisie($(contextModificationButton));
                                    } else {
                                        var redirectUrl = generateCreateElementUrl();
                                        if (redirectUrl) {
                                            window.location.href = redirectUrl;
                                        }
                                    }
                                }
                            }, {
                                text: LOCALE_BO.fermer,
                                click: function () {
                                    $(this).dialog('close');
                                }
                            }],
                            title: LOCALE_BO.confirmer
                        });
            });
    }
    /**
     * Génère l'url de saisie de contexte sur la base des infos contenus dans un écran de saisie de fiche.
     * @returns {*} l'url de saisie de contexte
     */
    function generateCreateElementUrl() {
        var formElement = document.querySelector('form#saisie_objet');
        var extInput = formElement.querySelector('input[name="EXT"]');
        var procInput = formElement.querySelector('input[name="PROC"]');
        if (!extInput || !procInput || !formElement) {
            return "";
        }
        return formElement.action + '?EXT=' + extInput.value + '&PROC=' + procInput.value + '&ACTION=AJOUTER'
    }
    function initSearchTranslation() {
        // Gestion des listes "Langue" et "ET n'ayant pas de traduction en "
        // présentes sur l'écran de recherche en BO.
        var listLangue = document.querySelector('#LANGUE');
        var langueNoTranslated = document.querySelector('#LANGUE_NON_TRADUITE');
        if (listLangue && langueNoTranslated) {
            listLangue.addEventListener('change', function () {
                var selectedLangue = listLangue.value;
                if ('0000' !== selectedLangue) {
                    if(langueNoTranslated.disabled ){
                        langueNoTranslated.disabled = false;
                    }
                    var optionsLangue = langueNoTranslated.querySelectorAll('option');
                    [].forEach.call(optionsLangue, function(option) {
                        if(option.value === selectedLangue){
                            option.setAttribute('disabled','disabled');
                        } else {
                            if(option.hasAttribute('disabled')){
                                option.removeAttribute('disabled');
                            }
                        }
                    });
                } else {
                    langueNoTranslated.value = '0000';
                    langueNoTranslated.disabled = true;
                }
            });
        }
    }

    initSearchTranslation();

})(jQuery.noConflict());
